import TradePlayerPoolList from "../../Fantasy/Trades/TradePlayerPoolList";
import StatsCentrePlayerPoolListPlayer from '../StatsCentrePlayerPoolListPlayer'
import StatsCentreEmptyPlayerPoolView from '../StatsCentrePlayerPoolListPlayer/Empty'

export class StatsCentrePlayerPoolList extends TradePlayerPoolList {
	get childView() {
		return StatsCentrePlayerPoolListPlayer;
	}

	get emptyView() {
		return StatsCentreEmptyPlayerPoolView;
	}

	init(args) {

		const {
			players,
			is_coach_enabled,
			has_assistant_coach,
			next_round_id
		} = args;

		const players_list = players.map(player => ({
			...player,
			is_locked: false,
			is_coach_enabled,
			has_assistant_coach,
			next_round_id
		}));

		this.collection.reset(players_list, { silent: true });
		this.filterBy(this.filters || {});

		return this;
	}
}

export default StatsCentrePlayerPoolList;